import { AsyncAction } from '../../base-classes';
import { ArityProvider } from '../providers/arityProvider';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_ARITY_OPT_IN = new AsyncAction('GET_ARITY_OPT_IN');

export function getArityOptIn(...params) {
    let paramsObject = {
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        options: undefined,
        logger: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);
    return {
        type: GET_ARITY_OPT_IN.base,
        payload: getArityOptInAction(paramsObject)
    };
}

async function getArityOptInAction({ baseUrl, authId, secret, options, logger, stdParameters, verbose, refresh }) {
    const op = new ArityProvider(baseUrl, authId, secret, options, logger);
    const results = await op.getArityOptIn(stdParameters, verbose, refresh);
    return results;
}
